type ScriptLoadingState = 'loading' | 'loaded' | undefined;

export type ScriptsState = {
  swipable: ScriptLoadingState;
}

export const scripts: ScriptsState = {
  swipable: undefined,
};
